export const handleGetAllData = (res) => res.data['hydra:member'];
